var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-dialog",
    {
      attrs: { width: "500px" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "LinkItem",
                _vm._g(
                  {
                    key: "export_csv",
                    attrs: {
                      text: "Export as ASFF",
                      icon: "mdi-file-document-multiple",
                    },
                    on: { click: _vm.showModal },
                  },
                  on
                )
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showingModal,
        callback: function ($$v) {
          _vm.showingModal = $$v
        },
        expression: "showingModal",
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(" Export as ASFF "),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-text-field",
                {
                  attrs: { label: "AWS Account ID" },
                  model: {
                    value: _vm.awsAccountId,
                    callback: function ($$v) {
                      _vm.awsAccountId = $$v
                    },
                    expression: "awsAccountId",
                  },
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { slot: "append", bottom: "" },
                      slot: "append",
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g({ attrs: { dark: "" } }, on),
                                [_vm._v(" mdi-information-outline ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "To find your Account ID, log into the AWS management console,"
                        ),
                        _c("br"),
                        _vm._v(
                          " In navigation bar, click the dropdown containing your username"
                        ),
                        _c("br"),
                        _vm._v(
                          ' Your Account ID will be listed next to "My Account". '
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-text-field",
                {
                  attrs: { label: "Target Name" },
                  model: {
                    value: _vm.target,
                    callback: function ($$v) {
                      _vm.target = $$v
                    },
                    expression: "target",
                  },
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { slot: "append", bottom: "" },
                      slot: "append",
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g({ attrs: { dark: "" } }, on),
                                [_vm._v(" mdi-information-outline ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "The target name is a user-defined string that is used to update existing controls in Security Hub."
                        ),
                        _c("br"),
                        _vm._v(
                          " If you upload a different results set of the same controls and using the same target name, the existing"
                        ),
                        _c("br"),
                        _vm._v(" findings in Security Hub will be updated. "),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-text-field",
                {
                  attrs: { label: "Region" },
                  model: {
                    value: _vm.region,
                    callback: function ($$v) {
                      _vm.region = $$v
                    },
                    expression: "region",
                  },
                },
                [
                  _c(
                    "v-tooltip",
                    {
                      attrs: { slot: "append", bottom: "" },
                      slot: "append",
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  {
                                    attrs: { dark: "" },
                                    on: { click: _vm.openRegionDocumentation },
                                  },
                                  on
                                ),
                                [_vm._v(" mdi-information-outline ")]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c(
                        "span",
                        [
                          _vm._v(
                            "Choose the region that contains the Security Hub instance you would like to upload findings to."
                          ),
                          _c("br"),
                          _vm._v(" Click the "),
                          _c("v-icon", { attrs: { dense: "" } }, [
                            _vm._v("mdi-information-outline"),
                          ]),
                          _vm._v(" icon to see a list of regions. "),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { text: "" }, on: { click: _vm.closeModal } },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "primary",
                    text: "",
                    disabled: _vm.exportDisabled,
                  },
                  on: { click: _vm.exportASFF },
                },
                [_vm._v(" Export ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }